import DocumentCreationButton from 'Components/DocumentCreationButton';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import { moca } from 'neuro-schemas';
import { exists } from 'neuro-utils';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import DescriptionText from 'Routes/Cognition/utils/DescriptionText';
import { formatPartialDate } from 'Utility/date';

const { calculateScore } = moca;

const MOCA = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => {
  const unableToPerformFound = documents.some(d => d.unableToPerform === true);
  return (
    <HistorySection
      headerText={<FormattedMessage id="cognition.moca.mocaLong" />}
      newButton={
        <DocumentCreationButton
          name="moca"
          text={'cognition.moca.newMoca'}
          onClick={startEdit({}, 'moca')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
      headerInfoText={<DescriptionText type={'moca'} />}
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id="general.date" />
            </Item>
            <Item xs={3}>
              <FormattedMessage id="cognition.moca.moca" /> (0-30)
            </Item>
            <Item xs={2}>
              <FormattedMessage id="cognition.additionalInfo" />
            </Item>
            <Item xs={5}>{unableToPerformFound ? <FormattedMessage id="general.reason" /> : ''}</Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2}>{formatPartialDate(d.date ?? undefined)}</Item>
            <Item xs={3}>
              {d.unableToPerform ? (
                <FormattedMessage id="cognition.unableToPerform" />
              ) : d.totalScoreOnly?.[0] ? (
                d.totalScore
              ) : (
                calculateScore(d)
              )}
            </Item>
            <Item xs={unableToPerformFound ? 2 : 4}>{d.additionalInfo}</Item>
            {unableToPerformFound ? (
              <Item xs={2}>
                {d.unableToPerform ? (exists(d.unableToPerformReason) ? d.unableToPerformReason : '-') : ''}
              </Item>
            ) : null}
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} view={view} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'moca'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default MOCA;
